import UrlEndpoints from "../client/UrlEndpoints";
import axios from 'axios';
import {
    handleResponse,
    handleErrorResponse
} from '../client/helpers/AuthHelper';
import {
    TRANSLATE_REGISTRATION_SUCCESS_ACTION,
    TRANSLATE_REGISTRATION_ERROR_ACTION,
    TRANSLATE_RESET_PASSWORD_SUCCESS_ACTION,
    TRANSLATE_RESET_PASSWORD_ERROR_ACTION,
    TRANSLATE_LOADING_ACTION,
    TRANSLATE_LOGIN_SUCCESS_ACTION,
    TRANSLATE_LOGIN_ERROR_ACTION
} from "../translates/Translates";
import {getRequestConfig} from '../client/helpers/Helper';

export const REGISTRATION = 'REGISTRATION';
export const SET_LOADING_REGISTRATION = 'SET_LOADING_REGISTRATION';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_ERROR = 'REGISTRATION_ERROR';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const SET_LOADING_RESET_PASSWORD = 'SET_LOADING_RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const LOGIN = 'LOGIN';
export const SET_LOADING_LOGIN = 'SET_LOADING_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';


const registration = (username, password, password_again) => {
    let url = UrlEndpoints.SAVE_USER_DATA;
    let request_url = UrlEndpoints.getUrlEndpoint(url);
    let request_config = {};
    request_config = getRequestConfig();
    request_config.params = {
        username,
        password,
        password_again
    };
    return {
        type: REGISTRATION,
        payload: axios.post(request_url, request_config)
            .then(handleResponse)
            .catch((error) => {
                handleErrorResponse(error);
            })
    }
}

const setLoadingRegistration = () => {
    return {
        type: SET_LOADING_REGISTRATION,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const registrationSuccess = () => {
    return {
        type: REGISTRATION_SUCCESS,
        payload: TRANSLATE_REGISTRATION_SUCCESS_ACTION
    }
}

const registrationError = () => {
    return {
        type: REGISTRATION_ERROR,
        payload: TRANSLATE_REGISTRATION_ERROR_ACTION
    }
}

const login = (data) => {
    let url = UrlEndpoints.LOGIN_USER;
    let request_url = UrlEndpoints.getUrlEndpoint(url);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: LOGIN,
        payload: axios.post(request_url, data, request_config)
            .then((response) => {
                let return_token = {
                    value: response.data.access_token,
                    timestamp: (new Date().getTime() + response.data.expires_in * 1000),
                    re_token: response.data.refresh_token
                };
                localStorage.setItem("token", JSON.stringify(return_token));
            })
            //.then((response) => handleResponse(response))
            .catch((error) => {
                handleErrorResponse(error);
            })
    }
}

const setLoadingLogin = () => {
    return {
        type: SET_LOADING_LOGIN,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const loginSuccessful = () => {
    return {
        type: LOGIN_SUCCESS,
        payload: TRANSLATE_LOGIN_SUCCESS_ACTION
    }
}

const loginError = () => {
    return {
        type: LOGIN_ERROR,
        payload: TRANSLATE_LOGIN_ERROR_ACTION
    }
}


const resetPassword = (email) => {
    let url = UrlEndpoints.RESET_PASSWORD;
    let request_url = UrlEndpoints.getUrlEndpoint(url);
    let request_config = {};
    request_config = getRequestConfig();
    request_config.params = {
        email
    };
    return {
        type: RESET_PASSWORD,
        payload: axios.post(request_url, request_config)
            .then(handleResponse)
            .catch((error) => {
                handleErrorResponse(error);
            })
    }
}

const setLoadingResetPassword = () => {
    return {
        type: SET_LOADING_RESET_PASSWORD,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const resetPasswordSuccess = () => {
    return {
        type: RESET_PASSWORD_SUCCESS,
        payload: TRANSLATE_RESET_PASSWORD_SUCCESS_ACTION
    }
}

const resetPasswordError = () => {
    return {
        type: RESET_PASSWORD_ERROR,
        payload: TRANSLATE_RESET_PASSWORD_ERROR_ACTION
    }
}


export {
    registration,
    setLoadingRegistration,
    registrationSuccess,
    registrationError,
    login,
    setLoadingLogin,
    loginSuccessful,
    loginError,
    resetPassword,
    setLoadingResetPassword,
    resetPasswordSuccess,
    resetPasswordError,
}
